export default "__VITE_ASSET__DUZumrZN__"